// SPDX-License-Identifier: MIT
// Shared section wrapper for the unified card: a carnet-style labelled header + a
// body slot, so platform-specific blocks (online-preview, agent panel, handoff)
// render under identical chrome on web and desktop.
import { escapeHtml } from '../lib/escape';

export function renderProjectSection(label: string, body: HTMLElement): HTMLElement {
  const section = document.createElement('section');
  section.className = 'project-section';
  section.innerHTML = `<div class="project-section__header">${escapeHtml(label)}</div><div class="project-section__body"></div>`;
  section.querySelector('.project-section__body')!.appendChild(body);
  return section;
}
